export const setBorrowerDetailsAction = (state = {}, action) => {
  switch (action.type) {
    case "SET_BORROWER_DETAILS":
      return action.data;

    default:
      return state;
  }
};
